var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('iq-card', {
    attrs: {
      "body-class": "p-0"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function fn() {
        return [_c('div', {
          staticClass: "iq-edit-list"
        }, [_c('tab-nav', {
          staticClass: "nav-fill mb-3",
          attrs: {
            "pills": true
          }
        }, [_c('tab-nav-items', {
          staticClass: "col-md-2 p-0",
          attrs: {
            "active": true,
            "href": "#spesification",
            "title": "Spesification"
          },
          nativeOn: {
            "click": function click($event) {
              _vm.tab = 'spesification';
            }
          }
        }), _c('tab-nav-items', {
          staticClass: "col-md-2 p-0",
          attrs: {
            "active": false,
            "href": "#category",
            "title": "Item Category"
          },
          nativeOn: {
            "click": function click($event) {
              _vm.tab = 'category';
            }
          }
        })], 1)], 1)];
      },
      proxy: true
    }])
  })], 1), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('div', {
    staticClass: "tab-content"
  }, [_c('tab-content-item', {
    attrs: {
      "active": true,
      "id": "spesification"
    }
  }, [_c('MasterSpesification', {
    attrs: {
      "refreshMasterData": _vm.refreshMasterData
    }
  })], 1), _c('tab-content-item', {
    attrs: {
      "active": false,
      "id": "category"
    }
  }, [_c('MasterMaterialCategory', {
    attrs: {
      "refreshMasterData": _vm.refreshMasterData
    }
  })], 1)], 1)])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }